import React from "react";

// "No data yet / nothing in this selection". A campaign that does not collect a field hides the panel instead.
export const EmptyState = ({ children }) => (
  <div className="ff-state-msg" role="status">{children}</div>
);
